export const mmTabData = [
  { id: "expert-review", label: "Expert opinion" },
  { id: "chat", label: "Chat" },
  { id: "specs", label: "Specs" },
  { id: "variants", label: "Variants" },
  { id: "comparison", label: "Comparison" },
];
